// src/protocols/dividends.js — протоколи за дивиденти (Фаза 3.2).

import { el, clear, $, field, input, row, clickableRow } from '../shared/dom.js';
import { numberLine } from '../shared/docNumber.js';
import { round2 } from '../../services/totals.js';
import { dateInput, guardDates } from '../shared/dates.js';
import { money, dfmt } from '../shared/format.js';
import { toast } from '../shared/toast.js';
import { api } from '../shared/api.js';
import { emptyState, docNo } from '../shared/ui.js';
import { regHead, regCount, REG_TABLE } from '../shared/register.js';
import { openModal, closeModal, confirmDialog } from '../shared/modal.js';
import { state, cq, activeCompanyObj, isAdminUser } from '../shared/state.js';

export async function view(host){
  clear(host);
  if (!state().activeCompany) return window.CRM.needsCompany(host);
  let list=[];
  try{ list = await api('/dividends'+cq()); }catch(e){ toast(e.message,true); }
  const panel=el('div',{class:'panel'});
  // Видът е като в „Доставки" (Макс, 29.10.2026): бутонът на реда със заглавието, броячът над таблицата.
  panel.appendChild(regHead('Протоколи за дивиденти', [], el('button',{class:'btn sm', type:'button', text:'+ Нов протокол', onClick:function(){ dividendForm(null); }})));
  if(!list.length){ panel.appendChild(emptyState('◈','Още няма протоколи за дивиденти.','+ Нов протокол', function(){ dividendForm(null); })); host.appendChild(panel); return; }
  const tb=el('tbody');
  list.slice().sort(function(a,b){ return (b.seq||0)-(a.seq||0); }).forEach(function(dv){
    var rate=(dv.tax_rate===''||dv.tax_rate==null)?5:(Number(dv.tax_rate)||0);
    var netTot=(dv.partners||[]).reduce(function(s,p){ var g=Number(p.gross)||0; var tax=round2(g*rate/100); return s+(g-tax); },0);
    // clickableRow: достъпен и с клавиатура (правилото от CLAUDE.md).
    tb.appendChild(clickableRow(function(){ dividendForm(dv); }, 'Отвори протокол № ' + (dv.number || ''),
      el('td',{},'№ ',docNo(dv.number)),
      el('td',{text: dfmt(dv.protocol_date)}),
      el('td',{text: dv.company_type==='eood'?'ЕООД':'ООД'}),
      el('td',{class:'num', text: money(Math.round(netTot*100)/100, dv.currency||'EUR')})
    ));
  });
  const countLbl=regCount(); countLbl.set(list.length, list.length); panel.appendChild(countLbl);
  panel.appendChild(el('table',{class:REG_TABLE}, el('thead',{},el('tr',{}, el('th',{text:'№'}), el('th',{text:'Дата'}), el('th',{text:'Тип'}), el('th',{class:'num',text:'Нето общо'}))), tb));
  host.appendChild(panel);
}

// existing може да е и ПРЕДПОПЪЛВАНЕ без id (мостът от калкулатора):
// тогава формата се отваря като „Нов протокол" с готови редове и суми,
// потребителят преглежда и чак „Запази" създава записа (с пореден номер).
export function dividendForm(existing){
  const dv = existing || {};
  const _company = (dv.company_id && (state().companies || []).find(function(c){ return Number(c.id) === Number(dv.company_id); })) || activeCompanyObj() || {};
  let partners = (dv.partners && dv.partners.length) ? dv.partners.map(function(p){ return { name:p.name, egn:p.egn, percent:p.percent, gross:p.gross }; }) : [{name:'',egn:'',percent:'',gross:''}];
  const f = {
    company_type: el('select',{}, el('option',{value:'ood',text:'ООД (съдружници)',selected:(dv.company_type||'ood')==='ood'}), el('option',{value:'eood',text:'ЕООД (едноличен собственик)',selected:dv.company_type==='eood'})),
    protocol_date: dateInput(dv.protocol_date || new Date().toISOString().slice(0,10)),
    place: input({value: dv.place || _company.city || ''}),
    owner_name: input({value: dv.owner_name || _company.mol || ''}),
    total_profit: input({type:'number',step:'0.01',value: dv.total_profit!=null?dv.total_profit:''}),
    payment_deadline: dateInput(dv.payment_deadline||''),
    payment_method: input({value: dv.payment_method || 'банков път'}),
    tax_rate: input({type:'number',step:'0.01',value: dv.tax_rate!=null?dv.tax_rate:5}),
    notes: el('textarea',{}, dv.notes||''),
  };
  const totalsBox = el('div',{style:'margin-top:8px;padding-top:8px;border-top:1px solid var(--border)'});
  const partsBody = el('tbody');
  // Ставка 0 е валидна (не пада към 5) — само празно поле дава 5.
  function rateVal(){ var v=f.tax_rate.value; return v===''||v==null ? 5 : (Number(v)||0); }
  function recompute(){
    var rate=rateVal(); var g=0,t=0,n=0;
    partners.forEach(function(p){ var gg=Number(p.gross)||0; var tax=round2(gg*rate/100); g+=gg; t+=tax; n+=(gg-tax); });
    clear(totalsBox);
    totalsBox.appendChild(el('div',{class:'line'}, el('span',{text:'Бруто общо'}), el('span',{text: money(Math.round(g*100)/100,'EUR')})));
    totalsBox.appendChild(el('div',{class:'line'}, el('span',{text:'Данък '+rate+'%'}), el('span',{text: money(Math.round(t*100)/100,'EUR')})));
    totalsBox.appendChild(el('div',{class:'line grand'}, el('span',{text:'Нето за изплащане'}), el('span',{text: money(Math.round(n*100)/100,'EUR')})));
  }
  function drawParts(){
    clear(partsBody);
    partners.forEach(function(p, idx){
      var name=input({value:p.name, placeholder:'Име', onInput:function(e){ p.name=e.target.value; }});
      var egn=input({value:p.egn, placeholder:'ЕГН', onInput:function(e){ p.egn=e.target.value; }});
      var pct=input({type:'number',step:'0.01',value:p.percent, onInput:function(e){ p.percent=e.target.value; }});
      var taxCell=el('td',{class:'num'}); var netCell=el('td',{class:'num'});
      var gross=input({type:'number',step:'0.01',value:p.gross, onInput:function(e){ p.gross=e.target.value; recompute(); calcCell(); }});
      function calcCell(){ var rate=rateVal(); var gg=Number(p.gross)||0; var tax=round2(gg*rate/100); clear(taxCell); taxCell.appendChild(el('span',{text: money(tax,'EUR')})); clear(netCell); netCell.appendChild(el('span',{text: money(Math.round((gg-tax)*100)/100,'EUR')})); }
      calcCell();
      partsBody.appendChild(el('tr',{},
        el('td',{}, name), el('td',{style:'width:120px'}, egn), el('td',{class:'num',style:'width:70px'}, pct), el('td',{class:'num',style:'width:100px'}, gross), taxCell, netCell,
        el('td',{style:'width:30px'}, el('button',{class:'btn sm danger',text:'×',onClick:function(){ partners.splice(idx,1); if(!partners.length)partners.push({name:'',egn:'',percent:'',gross:''}); drawParts(); recompute(); }}))
      ));
    });
  }
  f.tax_rate.addEventListener('input', function(){ recompute(); drawParts(); });
  drawParts(); recompute();
  const partsTable = el('table',{class:'items'}, el('thead',{},el('tr',{}, el('th',{text:'Съдружник'}), el('th',{text:'ЕГН'}), el('th',{class:'num',text:'Дял %'}), el('th',{class:'num',text:'Бруто'}), el('th',{class:'num',text:'Данък'}), el('th',{class:'num',text:'Нето'}), el('th'))), partsBody);
  const body = el('div',{},
    numberLine('/dividends', 'Новият протокол', existing),
    row(field('Тип', f.company_type), field('Дата', f.protocol_date)),
    row(field('Място', f.place), field('Данък %', f.tax_rate)),
    field('Обща печалба за разпределяне (EUR)', f.total_profit),
    el('h4',{text:'Съдружници / разпределение на дивидента', style:'margin:10px 0 6px'}),
    partsTable,
    el('button',{class:'btn sm ghost', text:'+ Съдружник', onClick:function(){ partners.push({name:'',egn:'',percent:'',gross:''}); drawParts(); }}),
    totalsBox,
    row(field('Срок за плащане', f.payment_deadline), field('Начин на плащане', f.payment_method)),
    field('Едноличен собственик (за ЕООД)', f.owner_name),
    field('Бележки', f.notes)
  );
  const save=async function(){
    // Неразбрана дата не тръгва празна — сървърът би сложил днешна (ПРОМТ-19).
    if (!guardDates(f.protocol_date)) return;
    const p={ company_id: dv.company_id || state().activeCompany, company_type: f.company_type.value, protocol_date: f.protocol_date.dataset.iso, place: f.place.value, owner_name: f.owner_name.value, total_profit: f.total_profit.value, tax_rate: f.tax_rate.value, payment_deadline: f.payment_deadline.dataset.iso, payment_method: f.payment_method.value, currency: 'EUR', notes: f.notes.value, partners: partners.map(function(x){ return {name:x.name, egn:x.egn, percent:x.percent, gross:x.gross}; }) };
    try{ if(existing&&existing.id) await api('/dividends/'+existing.id,{method:'PUT',body:JSON.stringify(p)}); else await api('/dividends',{method:'POST',body:JSON.stringify(p)}); toast('Записано.'); closeModal(); window.CRM.renderView($('#page')); }
    catch(e){ toast(e.message,true); }
  };
  const foot=el('div',{style:'flex-wrap:wrap'});
  if(existing&&existing.id){
    // „Създай подобен": нов протокол със същите съдружници и суми — без
    // id/номер (броячът дава номера при „Запази"), с днешна дата и без срок
    // за плащане. Маскирано ЕГН (не-админ) сървърът допопълва по име при
    // записа (enrichEgn) — същият модел като моста от калкулатора.
    foot.appendChild(el('button',{class:'btn sm ghost copy-btn',text:'Създай подобен',title:'Нов протокол със същите съдружници и суми',style:'margin-right:auto',onClick:function(){
      closeModal();
      dividendForm({
        company_id: existing.company_id,
        company_type: existing.company_type,
        place: existing.place,
        owner_name: existing.owner_name,
        total_profit: existing.total_profit,
        tax_rate: existing.tax_rate,
        payment_method: existing.payment_method,
        notes: existing.notes,
        partners: (existing.partners||[]).map(function(p){ return {name:p.name, egn:p.egn, percent:p.percent, gross:p.gross}; }),
      });
    }}));
    foot.appendChild(el('button',{class:'btn sm ghost',text:'PDF',onClick:function(){ window.open('/api/dividends/'+existing.id+'/pdf','_blank'); }}));
    if (isAdminUser()) foot.appendChild(el('button',{class:'btn sm danger',text:'Изтрий',onClick:async function(){ if(!(await confirmDialog('Да изтрия ли протокола?',{okText:'Изтрий',danger:true})))return; try{ await api('/dividends/'+existing.id,{method:'DELETE'}); toast('Изтрито.'); closeModal(); window.CRM.renderView($('#page')); }catch(e){ toast(e.message,true); } }}));
  }
  foot.appendChild(el('button',{class:'btn ghost',text:'Отказ',onClick:closeModal}));
  foot.appendChild(el('button',{class:'btn',text:'Запази',onClick:save,style:'margin-left:8px'}));
  openModal({title: (existing&&existing.id)?('Протокол за дивидент № '+existing.number):'Нов протокол за дивидент', body, foot, wide:true});
}
